import { isNil } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import './ExchangeAllShares.scss';

import { ExchangeTransactionActionType as act } from '../../../redux/modules/exchangeTransaction';
import {
  SELL_ALL_SHARES_CLOSED_TO_NEW_INVESTORS,
  SELL_ALL_SHARES_DAILY_LIMIT_MODAL,
  SELL_ALL_SHARES_MODAL,
} from '../../../redux/modules/modals/modals.module';
import { UNIT } from '../../../settings/settings';
import Checkbox from '../../Shared/Checkbox/Checkbox';
import { isCollegeAnything } from '../../../utils/transactions-util';
import words from '../../../utils/words';
import { getExchangeFromFundList } from '../../../redux/modules/exchangeTransaction/exchangeTransaction.selectors';
import { isAPP } from 'src/utils/advice/advice-utility';

class ExchangeAllShares extends Component {
  constructor(props) {
    super(props);
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { fund, openModal, updateExchangeFund } = this.props;
    const { agreementID, closeout, exceedsCloseoutDailyLimit, sweep } = fund;
    let { openToNewInvestors } = fund;
    const shouldCloseoutPrev =
      isNil(prevProps.fund.closeout) || !prevProps.fund.closeout;

    if (shouldCloseoutPrev && closeout) {
      if (sweep) {
        // if sweep and no uncollected shares, we don't show any pop-up. Update grossAmount in fund object.
        updateExchangeFund(act.UPDATE_EXCHANGE_FROM_FUND, {
          agreementID,
          grossAmount: 100,
          grossUnit: UNIT.ALL_SHARES,
        });
        return;
      }
      let modalName = SELL_ALL_SHARES_MODAL;

      // 529 portfolios are all open to new investors.
      // Do not present closed to new investors modal,
      // set 'openToNewInvestors' flag to true
      if (isCollegeAnything() || isAPP(fund.productType)) {
        openToNewInvestors = true;
      }

      if (fund.redeemableFundDollars > fund.transactionLimit.maximum) {
        modalName = SELL_ALL_SHARES_CLOSED_TO_NEW_INVESTORS;
      } else if (exceedsCloseoutDailyLimit) {
        modalName = SELL_ALL_SHARES_DAILY_LIMIT_MODAL;
      } else if (!openToNewInvestors) {
        modalName = SELL_ALL_SHARES_CLOSED_TO_NEW_INVESTORS;
      }
      openModal(modalName, { fund });
    }
  }

  getTotalSelectedEquity = () => {
    const { funds } = this.props;
    return funds.reduce(
      (sum, f) =>
        sum +
        (f.selected && f.grossUnit === UNIT.ALL_SHARES ? f.equityAsOf : 0),
      0
    );
  };

  handleCheckboxClick() {
    const {
      fund: {
        agreementID,
        closeout,
        grossAmount,
        transactionLimit: { maximum },
      },
      updateExchangeFund,
    } = this.props;
    const shouldCloseout = isNil(closeout) || !closeout;
    const equityAsOf = this.getTotalSelectedEquity();
    const exceedsCloseoutDailyLimit = equityAsOf > maximum;
    /**
     * this was originally defaulted to zero but design didn't feel adding '0' to the input was a natural behavior
     * it was requested that we empty the input hence 'undefined' when user changes mind and no longer wants to close
     * */
    updateExchangeFund(act.UPDATE_EXCHANGE_FROM_FUND, {
      agreementID,
      closeout: shouldCloseout,
      exceedsCloseoutDailyLimit,
      grossAmount:
        shouldCloseout && !exceedsCloseoutDailyLimit ? grossAmount : undefined,
      grossUnit:
        shouldCloseout && !exceedsCloseoutDailyLimit
          ? UNIT.ALL_SHARES
          : UNIT.DOLLARS,
    });
  }

  render() {
    const {
      fund,
      fund: { agreementID, grossAmountError, closeout },
    } = this.props;
    const ALL_SHARES_TEXT = `Exchange all ${
      isAPP(fund.productType) ? 'investments' : words.shares
    } 
      ${
        isCollegeAnything() || fund.sweep
          ? ''
          : `& close 
          ${isAPP(fund.productType) ? 'account' : words.fund}`
      }`;
    return (
      <span
        className={`e2e-exchange-all-label exchange-all-shares-exchange-all-label ${
          grossAmountError ? 'exchange-all-shares-error' : ''
        }`}
      >
        <Checkbox
          ariaLabel={ALL_SHARES_TEXT}
          checked={closeout}
          e2eSuffix="exch-all-and-close"
          id={`exchange-all-${agreementID}`}
          inline
          onClick={this.handleCheckboxClick}
        />

        <label
          htmlFor={`exchange-all-${agreementID}`}
          className={`exchange-all-shares-sub-label`}
        >
          {ALL_SHARES_TEXT}
        </label>
      </span>
    );
  }
}

const mapStateToProps = (state) => ({
  funds: getExchangeFromFundList(state),
});

export default compose(connect(mapStateToProps))(ExchangeAllShares);
